// extracted by mini-css-extract-plugin
module.exports = {"Figure":"Figure_Figure__mGx3e","Pending":"Figure_Pending__3pO92","Resolved":"Figure_Resolved__K95IR","Rejected":"Figure_Rejected__xBpn7","Caption":"Figure_Caption__3N4P2"};